import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Shield, Cpu, Globe, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
    const features = [
        { icon: <Rocket size={24} />, title: 'Fast Performance', description: 'Optimized code for blazing fast load times and smooth user experience.' },
        { icon: <Shield size={24} />, title: 'Secure & Robust', description: 'Enterprise-grade security standards to keep your data and users safe.' },
        { icon: <Cpu size={24} />, title: 'Modern Tech Stack', description: 'Built with the latest technologies like React, Next.js, and Node.js.' },
        { icon: <Globe size={24} />, title: 'Scalable Solutions', description: 'Architecture designed to grow perfectly with your business needs.' },
    ];

    return (
        <div className="home-container">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="container hero-content">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="hero-text"
                    >
                        <div className="badge">Innovation & Excellence</div>
                        <h1 className="hero-title">
                            We Build <br />
                            <span className="gradient-text">Future-Ready</span> <br />
                            Digital Experiences
                        </h1>
                        <p className="hero-description">
                            Aadhar Infotech is a premier software development agency specializing in cutting-edge web and mobile solutions. We turn your ambitious ideas into reality.
                        </p>
                        <div className="hero-btns">
                            <Link to="/portfolio" className="btn btn-primary">Our Work</Link>
                            <Link to="/contact" className="btn btn-outline">
                                Contact Us <ArrowRight size={18} />
                            </Link>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1 }}
                        className="hero-image"
                    >
                        <div className="blob-bg"></div>
                        <img
                            src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=800"
                            alt="Tech Dashboard"
                        />
                    </motion.div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Why Choose Us?</h2>
                        <p className="section-subtitle">We combine technical expertise with creative vision to deliver excellence.</p>
                    </div>
                    <div className="features-grid">
                        {features.map((f, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: i * 0.1 }}
                                viewport={{ once: true }}
                                className="feature-card glass-morphism"
                            >
                                <div className="feature-icon">{f.icon}</div>
                                <h3>{f.title}</h3>
                                <p>{f.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Home;
